import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const reviews = [{
    text: 'Viele Jahre viel Geld ausgegeben. Nichts hat geholfen. Um so überraschter war ich, als schon nach 14 Tagen Besserung eintrat. Heute geht es unserer Lotta so gut wie nie.',
    author: 'Martina, Hundemama aus München'
  }, {
    text: 'Es hat so geholfen und gewirkt, wie sie es beschreiben. Nach zwei Wochen hatte unser Hund keine Beschwerden mehr.',
    author: 'Thomas, Besitzer eines Golden Retrievers'
  }, {
    text: 'Endlich ein Zusatz, der wirklich wirkt. Meine Hündin ist sichtbar fitter, aktiver, wacher – ohne Verdauungsprobleme.',
    author: 'Nadja & Sonnenblume'
  }];
  return <section className="max-w-3xl mx-auto px-6 py-16" data-id="element-86">
      <div className="text-center mb-10" data-id="element-87">
        <h2 className="text-2xl font-bold text-brand-brown mb-3" data-id="element-88">
          Nicht nur Max geht es besser
        </h2>
        <p className="text-stone-600 font-serif" data-id="element-89">
          In der Facebook-Gruppe habe ich noch viele weitere ähnliche
          Geschichten gefunden:
        </p>
      </div>

      <div className="space-y-6" data-id="element-90">
        {reviews.map((review, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.15
      }} className="bg-white p-6 rounded-xl shadow-sm border border-stone-200 relative" data-id="element-91">
            <div className="flex gap-1 mb-3" data-id="element-92">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-amber text-brand-amber" data-id="element-93" />)}
            </div>
            <p className="font-serif text-lg text-stone-700 italic mb-4" data-id="element-94">
              "{review.text}"
            </p>
            <p className="font-sans font-medium text-stone-500 text-sm" data-id="element-95">
              – {review.author}
            </p>
          </motion.div>)}
      </div>
    </section>;
}